import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CourseIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Course",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.18 2.23H7.13C4.3 2.23 2 4.53 2 7.36v17.11c0 2.83 2.3 5.13 5.13 5.13h15.04c.94 0 1.71-.77 1.71-1.71 0-.12-.01-.24-.03-.34-.18-.79-.88-1.37-1.71-1.37H7.13c-.94 0-1.71-.77-1.71-1.71 0-.12.01-.24.03-.34.18-.79.88-1.37 1.71-1.37h15.01c.94 0 1.71-.77 1.71-1.71V3.94c0-.94-.77-1.71-1.71-1.71ZM26.47 7.48H30v18.94h-3.53zM28.88 2.23h-1.3c-.62 0-1.12.5-1.12 1.12v2.54h3.53V3.35c0-.62-.5-1.12-1.12-1.12ZM27.59 29.37c.39.64 1.08.43 1.31 0l1.1-1.94h-3.53c.02.07.74 1.34 1.12 1.95Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M20.81 29.28h-7.38c-.63 0-1.14-.51-1.14-1.14v-7.38c0-.3.12-.59.33-.81l8.62-8.62c.21-.21.5-.33.81-.33.3 0 .59.12.81.33l7.38 7.39c.45.45.45 1.17 0 1.62l-8.62 8.61c-.21.21-.5.33-.81.33M14.57 27h5.77l7.47-7.47-5.77-5.77-7.47 7.47z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M26 24.1c-.29 0-.58-.11-.81-.33l-7.38-7.38a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l7.38 7.38A1.14 1.14 0 0 1 26 24.1M22.57 8.71h-16a1.14 1.14 0 1 1 0-2.28h16a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.86 29.28H6.57c-3.15 0-5.71-2.56-5.71-5.71v-16c0-3.15 2.56-5.71 5.71-5.71h16a1.14 1.14 0 1 1 0 2.28h-16c-1.89 0-3.43 1.54-3.43 3.43v16c0 1.89 1.54 3.43 3.43 3.43h2.29a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
CourseIcon.displayName = 'CourseIcon';